/**
 * Tokens → the `--nvd-*` variables the SCSS renders from. This map is the whole contract between config
 * and styling: adding a token is one entry here and one `var()` in the SCSS.
 */
export function themeVars(theme, brand) {
    const vars = {
        '--nvd-color-accent': theme.colors.accent,
        '--nvd-color-accent-text': theme.colors.accentText,
        '--nvd-color-panel': theme.colors.panel,
        '--nvd-color-panel-text': theme.colors.panelText,
        '--nvd-color-surface': theme.colors.surface,
        '--nvd-color-page': theme.colors.page,
        '--nvd-color-text': theme.colors.text,
        '--nvd-color-muted': theme.colors.muted,
        '--nvd-color-border': theme.colors.border,
        '--nvd-color-notice-bg': theme.colors.noticeBg,
        '--nvd-color-notice-icon': theme.colors.noticeIcon,
        '--nvd-color-danger': theme.colors.danger,
        '--nvd-radius-card': `${theme.radius.card}px`,
        '--nvd-radius-control': `${theme.radius.control}px`,
        '--nvd-radius-button': `${theme.radius.button}px`,
        '--nvd-font-scale': String(theme.font.scale),
    };
    if (theme.font.heading)
        vars['--nvd-font-heading'] = theme.font.heading;
    if (theme.font.body)
        vars['--nvd-font-body'] = theme.font.body;
    if (brand?.backgroundUrl) {
        vars['--nvd-bg-image'] = `url("${brand.backgroundUrl.replace(/["\\]/g, '')}")`;
        vars['--nvd-bg-size'] = brand.backgroundFit === 'tile' ? 'auto' : brand.backgroundFit;
        vars['--nvd-bg-repeat'] = brand.backgroundFit === 'tile' ? 'repeat' : 'no-repeat';
        vars['--nvd-bg-overlay'] = String(brand.backgroundOverlay);
    }
    return vars;
}
/** The same map as a style attribute value, for server-rendered markup. */
export function themeStyle(theme, brand) {
    return Object.entries(themeVars(theme, brand))
        .map(([name, value]) => `${name}:${value}`)
        .join(';');
}
//# sourceMappingURL=theme.js.map